import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks, BodyScrollOptions } from 'body-scroll-lock';

var sliders = {
	init: function () {
		var self = this;

		self.slideshow();
		self.slideshow_custom_widths();
	},

	slideshow: function () {
		if( jQuery( '.js-slideshow' ).length ) {
			jQuery( '.js-slideshow:not(.tns-slider)' ).each(function() {
				var items_on_line = jQuery(this).data( 'items' );

				if( items_on_line == "1" ) {
					var items_on_line_tablet = 1;
				}
				else if( items_on_line < "4") {
					var items_on_line_tablet = items_on_line - 1;
				}
				else if( items_on_line > "3") {
					var items_on_line_tablet = items_on_line - 2;
				}
				else {
					var items_on_line_tablet = 1;
					items_on_line = 1;
				}


				var slider = tns({
					container: this,
					items: items_on_line,
					autoplay: false,
					loop: false,
					mouseDrag: true,
					controls: true,
					responsive: {
						0: {
							items: 1,
							controls: true,
						},
						640: {
							items: items_on_line_tablet,
							controls: true,
						},
						992: {
							items: items_on_line,
							controls: true,
						}
					}
				});
			});
	
		}
	},
	
	
	slideshow_custom_widths: function () {
		if( jQuery( '.js-slideshow-custom-widths' ).length ) {
			jQuery( '.js-slideshow-custom-widths:not(.tns-slider)' ).each(function() {
				var slideshow_custom_widths = tns({
					container: this,
					autoWidth: false,
					items: 6,
					gutter: 16,
					controls: true,
					mouseDrag: true,
					swipeAngle: false,
					speed: 400,
					loop: false,
					center: false,
					controls: true,
					responsive: {
						0: {
							items: 3,
						},
						640: {
							items: 4,
						},
						992: {
							items: 7,
						}
					}
				});
			});
		}
	},
};

export { sliders };
